const countriesPt = [
    {
        "gentilico": "afegãne",
        "pt": "Afeganistão",
        "code": "AF"
    },
    {
        "gentilico": "sul-africana",
        "pt": "África do Sul",
        "code": "ZA"
    },
    {
        "gentilico": "albanesa",
        "pt": "Albânia",
        "code": "AL"
    },
    {
        "gentilico": "alemã",
        "pt": "Alemanha",
        "code": "DE"
    },
    {
        "gentilico": "andorrana",
        "pt": "Andorra",
        "code": "AD"
    },
    {
        "gentilico": "angolana",
        "pt": "Angola",
        "code": "AO"
    },
    {
        "gentilico": "anguillana",
        "pt": "Anguilla",
        "code": "AI"
    },
    {
        "gentilico": "de antártida",
        "pt": "Antártida",
        "code": "AQ"
    },
    {
        "gentilico": "antiguana",
        "pt": "Antígua e Barbuda",
        "code": "AG"
    },
    {
        "gentilico": "saudita",
        "pt": "Arábia Saudita",
        "code": "SA"
    },
    {
        "gentilico": "argelina",
        "pt": "Argélia",
        "code": "DZ"
    },
    {
        "gentilico": "argentina",
        "pt": "Argentina",
        "code": "AR"
    },
    {
        "gentilico": "armênia",
        "pt": "Armênia",
        "code": "AM"
    },
    {
        "gentilico": "arubana",
        "pt": "Aruba",
        "code": "AW"
    },
    {
        "gentilico": "australiana",
        "pt": "Austrália",
        "code": "AU"
    },
    {
        "gentilico": "austríaca",
        "pt": "Áustria",
        "code": "AT"
    },
    {
        "gentilico": "azerbaijano",
        "pt": "Azerbaijão",
        "code": "AZ"
    },
    {
        "gentilico": "bahamense",
        "pt": "Bahamas",
        "code": "BS"
    },
    {
        "gentilico": "barenita",
        "pt": "Bahrein",
        "code": "BH"
    },
    {
        "gentilico": "bengali",
        "pt": "Bangladesh",
        "code": "BD"
    },
    {
        "gentilico": "barbadiana",
        "pt": "Barbados",
        "code": "BB"
    },
    {
        "gentilico": "bielo-russa",
        "pt": "Belarus",
        "code": "BY"
    },
    {
        "gentilico": "belga",
        "pt": "Bélgica",
        "code": "BE"
    },
    {
        "gentilico": "belizenha",
        "pt": "Belize",
        "code": "BZ"
    },
    {
        "gentilico": "beninense",
        "pt": "Benin",
        "code": "BJ"
    },
    {
        "gentilico": "bermudiana",
        "pt": "Bermudas",
        "code": "BM"
    },
    {
        "gentilico": "boliviana",
        "pt": "Bolívia",
        "code": "BO"
    },
    {
        "gentilico": "bósnia",
        "pt": "Bósnia-Herzegóvina",
        "code": "BA"
    },
    {
        "gentilico": "betchuana",
        "pt": "Botsuana",
        "code": "BW"
    },
    {
        "gentilico": "brasileira",
        "pt": "Brasil",
        "code": "BR"
    },
    {
        "gentilico": "bruneiana",
        "pt": "Brunei",
        "code": "BN"
    },
    {
        "gentilico": "búlgara",
        "pt": "Bulgária",
        "code": "BG"
    },
    {
        "gentilico": "burquinês",
        "pt": "Burkina Fasso",
        "code": "BF"
    },
    {
        "gentilico": "burundinesa",
        "pt": "Burundi",
        "code": "BI"
    },
    {
        "gentilico": "butanesa",
        "pt": "Butão",
        "code": "BT"
    },
    {
        "gentilico": "cabo-verdiana",
        "pt": "Cabo Verde",
        "code": "CV"
    },
    {
        "gentilico": "camaronesa",
        "pt": "Camarões",
        "code": "CM"
    },
    {
        "gentilico": "cambojana",
        "pt": "Camboja",
        "code": "KH"
    },
    {
        "gentilico": "canadense",
        "pt": "Canadá",
        "code": "CA"
    },
    {
        "gentilico": "canário",
        "pt": "Canárias",
        "code": "IC"
    },
    {
        "gentilico": "cazaque",
        "pt": "Cazaquistão",
        "code": "KZ"
    },
    {
        "gentilico": "de ceuta e melilla",
        "pt": "Ceuta e Melilla",
        "code": "EA"
    },
    {
        "gentilico": "chadiana",
        "pt": "Chade",
        "code": "TD"
    },
    {
        "gentilico": "chilena",
        "pt": "Chile",
        "code": "CL"
    },
    {
        "gentilico": "chinesa",
        "pt": "China",
        "code": "CN"
    },
    {
        "gentilico": "cipriota",
        "pt": "Chipre",
        "code": "CY"
    },
    {
        "gentilico": "cingapuriana",
        "pt": "Cingapura",
        "code": "SG"
    },
    {
        "gentilico": "colombiana",
        "pt": "Colômbia",
        "code": "CO"
    },
    {
        "gentilico": "comorense",
        "pt": "Comores",
        "code": "KM"
    },
    {
        "gentilico": "congolesa",
        "pt": "Congo",
        "code": "CG"
    },
    {
        "gentilico": "norte-coreano",
        "pt": "Coréia do Norte",
        "code": "KP"
    },
    {
        "gentilico": "norte-coreana",
        "pt": "Coréia do Sul",
        "code": "KR"
    },
    {
        "gentilico": "marfinense",
        "pt": "Costa do Marfim",
        "code": "CI"
    },
    {
        "gentilico": "costarriquenha",
        "pt": "Costa Rica",
        "code": "CR"
    },
    {
        "gentilico": "croata",
        "pt": "Croácia",
        "code": "HR"
    },
    {
        "gentilico": "cubana",
        "pt": "Cuba",
        "code": "CU"
    },
    {
        "gentilico": "curaçauense",
        "pt": "Curaçao",
        "code": "CW"
    },
    {
        "gentilico": "chagositano",
        "pt": "Diego Garcia",
        "code": "DG"
    },
    {
        "gentilico": "dinamarquesa",
        "pt": "Dinamarca",
        "code": "DK"
    },
    {
        "gentilico": "djibutiana",
        "pt": "Djibuti",
        "code": "DJ"
    },
    {
        "gentilico": "dominiquense",
        "pt": "Dominica",
        "code": "DM"
    },
    {
        "gentilico": "egípcia",
        "pt": "Egito",
        "code": "EG"
    },
    {
        "gentilico": "salvadorenha",
        "pt": "El Salvador",
        "code": "SV"
    },
    {
        "gentilico": "árabe",
        "pt": "Emirados Árabes Unidos",
        "code": "AE"
    },
    {
        "gentilico": "equatoriana",
        "pt": "Equador",
        "code": "EC"
    },
    {
        "gentilico": "eritreia",
        "pt": "Eritréia",
        "code": "ER"
    },
    {
        "gentilico": "eslovaco",
        "pt": "Eslováquia",
        "code": "SK"
    },
    {
        "gentilico": "esloveno",
        "pt": "Eslovênia",
        "code": "SI"
    },
    {
        "gentilico": "espanhola",
        "pt": "Espanha",
        "code": "ES"
    },
    {
        "gentilico": "norte-americana",
        "pt": "Estados Unidos",
        "code": "US"
    },
    {
        "gentilico": "estoniana",
        "pt": "Estônia",
        "code": "EE"
    },
    {
        "gentilico": "etíope",
        "pt": "Etiópia",
        "code": "ET"
    },
    {
        "gentilico": "fijiana",
        "pt": "Fiji",
        "code": "FJ"
    },
    {
        "gentilico": "filipina",
        "pt": "Filipinas",
        "code": "PH"
    },
    {
        "gentilico": "finlandesa",
        "pt": "Finlândia",
        "code": "FI"
    },
    {
        "gentilico": "francesa",
        "pt": "França",
        "code": "FR"
    },
    {
        "gentilico": "gabonesa",
        "pt": "Gabão",
        "code": "GA"
    },
    {
        "gentilico": "gambiana",
        "pt": "Gâmbia",
        "code": "GM"
    },
    {
        "gentilico": "ganense",
        "pt": "Gana",
        "code": "GH"
    },
    {
        "gentilico": "georgiana",
        "pt": "Geórgia",
        "code": "GE"
    },
    {
        "gentilico": "gibraltariana",
        "pt": "Gibraltar",
        "code": "GI"
    },
    {
        "gentilico": "inglesa",
        "pt": "Grã-Bretanha (Reino Unido, UK)",
        "code": "GB"
    },
    {
        "gentilico": "granadina",
        "pt": "Granada",
        "code": "GD"
    },
    {
        "gentilico": "grega",
        "pt": "Grécia",
        "code": "GR"
    },
    {
        "gentilico": "groenlandesa",
        "pt": "Groelândia",
        "code": "GL"
    },
    {
        "gentilico": "guadalupense",
        "pt": "Guadalupe",
        "code": "GP"
    },
    {
        "gentilico": "guamês",
        "pt": "Guam (Território dos Estados Unidos)",
        "code": "GU"
    },
    {
        "gentilico": "guatemalteca",
        "pt": "Guatemala",
        "code": "GT"
    },
    {
        "gentilico": "guernesiano",
        "pt": "Guernsey",
        "code": "GG"
    },
    {
        "gentilico": "guianense",
        "pt": "Guiana",
        "code": "GY"
    },
    {
        "gentilico": "franco-guianense",
        "pt": "Guiana Francesa",
        "code": "GF"
    },
    {
        "gentilico": "guinéu-equatoriano ou equatoguineana",
        "pt": "Guiné",
        "code": "GN"
    },
    {
        "gentilico": "guinéu-equatoriano",
        "pt": "Guiné Equatorial",
        "code": "GQ"
    },
    {
        "gentilico": "guineense",
        "pt": "Guiné-Bissau",
        "code": "GW"
    },
    {
        "gentilico": "haitiana",
        "pt": "Haiti",
        "code": "HT"
    },
    {
        "gentilico": "holandês",
        "pt": "Holanda",
        "code": "NL"
    },
    {
        "gentilico": "hondurenha",
        "pt": "Honduras",
        "code": "HN"
    },
    {
        "gentilico": "hong-konguiana ou chinesa",
        "pt": "Hong Kong",
        "code": "HK"
    },
    {
        "gentilico": "húngara",
        "pt": "Hungria",
        "code": "HU"
    },
    {
        "gentilico": "iemenita",
        "pt": "Iêmen",
        "code": "YE"
    },
    {
        "gentilico": "da ilha bouvet",
        "pt": "Ilha Bouvet",
        "code": "BV"
    },
    {
        "gentilico": "da ilha de ascensão",
        "pt": "Ilha de Ascensão",
        "code": "AC"
    },
    {
        "gentilico": "da ilha de clipperton",
        "pt": "Ilha de Clipperton",
        "code": "CP"
    },
    {
        "gentilico": "manês",
        "pt": "Ilha de Man",
        "code": "IM"
    },
    {
        "gentilico": "natalense",
        "pt": "Ilha Natal",
        "code": "CX"
    },
    {
        "gentilico": "pitcairnense",
        "pt": "Ilha Pitcairn",
        "code": "PN"
    },
    {
        "gentilico": "reunionense",
        "pt": "Ilha Reunião",
        "code": "RE"
    },
    {
        "gentilico": "alandês",
        "pt": "Ilhas Aland",
        "code": "AX"
    },
    {
        "gentilico": "caimanês",
        "pt": "Ilhas Cayman",
        "code": "KY"
    },
    {
        "gentilico": "coquense",
        "pt": "Ilhas Cocos",
        "code": "CC"
    },
    {
        "gentilico": "cookense",
        "pt": "Ilhas Cook",
        "code": "CK"
    },
    {
        "gentilico": "faroense",
        "pt": "Ilhas Faroes",
        "code": "FO"
    },
    {
        "gentilico": "das ilhas geórgia do sul e sandwich do sul",
        "pt": "Ilhas Geórgia do Sul e Sandwich do Sul",
        "code": "GS"
    },
    {
        "gentilico": "das ilhas heard e mcdonald",
        "pt": "Ilhas Heard e McDonald (Território da Austrália)",
        "code": "HM"
    },
    {
        "gentilico": "malvinense",
        "pt": "Ilhas Malvinas",
        "code": "FK"
    },
    {
        "gentilico": "norte-marianense",
        "pt": "Ilhas Marianas do Norte",
        "code": "MP"
    },
    {
        "gentilico": "marshallino",
        "pt": "Ilhas Marshall",
        "code": "MH"
    },
    {
        "gentilico": "das ilhas menores afastadas",
        "pt": "Ilhas Menores dos Estados Unidos",
        "code": "UM"
    },
    {
        "gentilico": "norfolquino",
        "pt": "Ilhas Norfolk",
        "code": "NF"
    },
    {
        "gentilico": "salomônico",
        "pt": "Ilhas Salomão",
        "code": "SB"
    },
    {
        "gentilico": "seichelense",
        "pt": "Ilhas Seychelles",
        "code": "SC"
    },
    {
        "gentilico": "toquelauano",
        "pt": "Ilhas Tokelau",
        "code": "TK"
    },
    {
        "gentilico": "turquês",
        "pt": "Ilhas Turks e Caicos",
        "code": "TC"
    },
    {
        "gentilico": "virginense",
        "pt": "Ilhas Virgens (Estados Unidos)",
        "code": "VI"
    },
    {
        "gentilico": "virginense",
        "pt": "Ilhas Virgens (Inglaterra)",
        "code": "VG"
    },
    {
        "gentilico": "indiano",
        "pt": "Índia",
        "code": "IN"
    },
    {
        "gentilico": "indonésia",
        "pt": "Indonésia",
        "code": "ID"
    },
    {
        "gentilico": "iraniano",
        "pt": "Irã",
        "code": "IR"
    },
    {
        "gentilico": "iraquiana",
        "pt": "Iraque",
        "code": "IQ"
    },
    {
        "gentilico": "irlandesa",
        "pt": "Irlanda",
        "code": "IE"
    },
    {
        "gentilico": "islandesa",
        "pt": "Islândia",
        "code": "IS"
    },
    {
        "gentilico": "israelense",
        "pt": "Israel",
        "code": "IL"
    },
    {
        "gentilico": "italiana",
        "pt": "Itália",
        "code": "IT"
    },
    {
        "gentilico": "jamaicana",
        "pt": "Jamaica",
        "code": "JM"
    },
    {
        "gentilico": "japonesa",
        "pt": "Japão",
        "code": "JP"
    },
    {
        "gentilico": "canalina",
        "pt": "Jersey",
        "code": "JE"
    },
    {
        "gentilico": "jordaniana",
        "pt": "Jordânia",
        "code": "JO"
    },
    {
        "gentilico": "kiribatiana",
        "pt": "Kiribati",
        "code": "KI"
    },
    {
        "gentilico": "kosovar",
        "pt": "Kosovo",
        "code": "XK"
    },
    {
        "gentilico": "kuwaitiano",
        "pt": "Kuait",
        "code": "KW"
    },
    {
        "gentilico": "laosiana",
        "pt": "Laos",
        "code": "LA"
    },
    {
        "gentilico": "lesota",
        "pt": "Lesoto",
        "code": "LS"
    },
    {
        "gentilico": "letão",
        "pt": "Letônia",
        "code": "LV"
    },
    {
        "gentilico": "libanesa",
        "pt": "Líbano",
        "code": "LB"
    },
    {
        "gentilico": "liberiana",
        "pt": "Libéria",
        "code": "LR"
    },
    {
        "gentilico": "líbia",
        "pt": "Líbia",
        "code": "LY"
    },
    {
        "gentilico": "liechtensteiniense",
        "pt": "Liechtenstein",
        "code": "LI"
    },
    {
        "gentilico": "lituana",
        "pt": "Lituânia",
        "code": "LT"
    },
    {
        "gentilico": "luxemburguesa",
        "pt": "Luxemburgo",
        "code": "LU"
    },
    {
        "gentilico": "macauense",
        "pt": "Macau",
        "code": "MO"
    },
    {
        "gentilico": "macedônio",
        "pt": "Macedônia (República Yugoslava)",
        "code": "MK"
    },
    {
        "gentilico": "malgaxe",
        "pt": "Madagascar",
        "code": "MG"
    },
    {
        "gentilico": "malaia",
        "pt": "Malásia",
        "code": "MY"
    },
    {
        "gentilico": "malauiano",
        "pt": "Malaui",
        "code": "MW"
    },
    {
        "gentilico": "maldívia",
        "pt": "Maldivas",
        "code": "MV"
    },
    {
        "gentilico": "malinesa",
        "pt": "Mali",
        "code": "ML"
    },
    {
        "gentilico": "maltesa",
        "pt": "Malta",
        "code": "MT"
    },
    {
        "gentilico": "marroquina",
        "pt": "Marrocos",
        "code": "MA"
    },
    {
        "gentilico": "martiniquense",
        "pt": "Martinica",
        "code": "MQ"
    },
    {
        "gentilico": "mauriciana",
        "pt": "Maurício",
        "code": "MU"
    },
    {
        "gentilico": "mauritana",
        "pt": "Mauritânia",
        "code": "MR"
    },
    {
        "gentilico": "maiotense",
        "pt": "Mayotte",
        "code": "YT"
    },
    {
        "gentilico": "mexicana",
        "pt": "México",
        "code": "MX"
    },
    {
        "gentilico": "micronésia",
        "pt": "Micronésia",
        "code": "FM"
    },
    {
        "gentilico": "moçambicana",
        "pt": "Moçambique",
        "code": "MZ"
    },
    {
        "gentilico": "moldavo",
        "pt": "Moldova",
        "code": "MD"
    },
    {
        "gentilico": "monegasca",
        "pt": "Mônaco",
        "code": "MC"
    },
    {
        "gentilico": "mongol",
        "pt": "Mongólia",
        "code": "MN"
    },
    {
        "gentilico": "montenegra",
        "pt": "Montenegro",
        "code": "ME"
    },
    {
        "gentilico": "montserratiano",
        "pt": "Montserrat",
        "code": "MS"
    },
    {
        "gentilico": "birmanês",
        "pt": "Myanma",
        "code": "MM"
    },
    {
        "gentilico": "namíbia",
        "pt": "Namíbia",
        "code": "NA"
    },
    {
        "gentilico": "nauruana",
        "pt": "Nauru",
        "code": "NR"
    },
    {
        "gentilico": "nepalesa",
        "pt": "Nepal",
        "code": "NP"
    },
    {
        "gentilico": "nicaraguense",
        "pt": "Nicarágua",
        "code": "NI"
    },
    {
        "gentilico": "nigerina",
        "pt": "Níger",
        "code": "NE"
    },
    {
        "gentilico": "nigeriana",
        "pt": "Nigéria",
        "code": "NG"
    },
    {
        "gentilico": "niueana",
        "pt": "Niue",
        "code": "NU"
    },
    {
        "gentilico": "norueguesa",
        "pt": "Noruega",
        "code": "NO"
    },
    {
        "gentilico": "caledônia",
        "pt": "Nova Caledônia",
        "code": "NC"
    },
    {
        "gentilico": "neozelandesa",
        "pt": "Nova Zelândia",
        "code": "NZ"
    },
    {
        "gentilico": "omani",
        "pt": "Omã",
        "code": "OM"
    },
    {
        "gentilico": "palauense",
        "pt": "Palau",
        "code": "PW"
    },
    {
        "gentilico": "palestino",
        "pt": "Palestina",
        "code": "PS"
    },
    {
        "gentilico": "zona do canal do panamá",
        "pt": "Panamá",
        "code": "PA"
    },
    {
        "gentilico": "pauásia",
        "pt": "Papua-Nova Guiné",
        "code": "PG"
    },
    {
        "gentilico": "paquistanesa",
        "pt": "Paquistão",
        "code": "PK"
    },
    {
        "gentilico": "paraguaia",
        "pt": "Paraguai",
        "code": "PY"
    },
    {
        "gentilico": "peruana",
        "pt": "Peru",
        "code": "PE"
    },
    {
        "gentilico": "franco-polinésia",
        "pt": "Polinésia Francesa",
        "code": "PF"
    },
    {
        "gentilico": "polonesa",
        "pt": "Polônia",
        "code": "PL"
    },
    {
        "gentilico": "portorriquenha",
        "pt": "Porto Rico",
        "code": "PR"
    },
    {
        "gentilico": "portuguesa",
        "pt": "Portugal",
        "code": "PT"
    },
    {
        "gentilico": "catarense",
        "pt": "Qatar",
        "code": "QA"
    },
    {
        "gentilico": "queniano",
        "pt": "Quênia",
        "code": "KE"
    },
    {
        "gentilico": "quirguiz",
        "pt": "Quirguistão",
        "code": "KG"
    },
    {
        "gentilico": "centro-africana",
        "pt": "República Centro-Africana",
        "code": "CF"
    },
    {
        "gentilico": "congolesa",
        "pt": "República Democrática do Congo",
        "code": "CD"
    },
    {
        "gentilico": "dominicana",
        "pt": "República Dominicana",
        "code": "DO"
    },
    {
        "gentilico": "tcheco",
        "pt": "República Tcheca",
        "code": "CZ"
    },
    {
        "gentilico": "romena",
        "pt": "Romênia",
        "code": "RO"
    },
    {
        "gentilico": "ruandesa",
        "pt": "Ruanda",
        "code": "RW"
    },
    {
        "gentilico": "russa",
        "pt": "Rússia (antiga URSS) - Federação Russa",
        "code": "RU"
    },
    {
        "gentilico": "saariano",
        "pt": "Saara Ocidental",
        "code": "EH"
    },
    {
        "gentilico": "pedro-miquelonense",
        "pt": "Saint-Pierre e Miquelon",
        "code": "PM"
    },
    {
        "gentilico": "samoana",
        "pt": "Samoa Americana",
        "code": "AS"
    },
    {
        "gentilico": "samoano",
        "pt": "Samoa Ocidental",
        "code": "WS"
    },
    {
        "gentilico": "samarinês",
        "pt": "San Marino",
        "code": "SM"
    },
    {
        "gentilico": "helenense",
        "pt": "Santa Helena",
        "code": "SH"
    },
    {
        "gentilico": "santa-lucense",
        "pt": "Santa Lúcia",
        "code": "LC"
    },
    {
        "gentilico": "são-bartolomeense",
        "pt": "São Bartolomeu",
        "code": "BL"
    },
    {
        "gentilico": "são-cristovense",
        "pt": "São Cristóvão e Névis",
        "code": "KN"
    },
    {
        "gentilico": "são-martinhense",
        "pt": "São Martim",
        "code": "MF"
    },
    {
        "gentilico": "são-martinhense",
        "pt": "São Martinho",
        "code": "SX"
    },
    {
        "gentilico": "são-tomense",
        "pt": "São Tomé e Príncipe",
        "code": "ST"
    },
    {
        "gentilico": "sao-vicentino",
        "pt": "São Vicente e Granadinas",
        "code": "VC"
    },
    {
        "gentilico": "senegalesa",
        "pt": "Senegal",
        "code": "SN"
    },
    {
        "gentilico": "leonesa",
        "pt": "Serra Leoa",
        "code": "SL"
    },
    {
        "gentilico": "síria",
        "pt": "Síria",
        "code": "SY"
    },
    {
        "gentilico": "somali",
        "pt": "Somália",
        "code": "SO"
    },
    {
        "gentilico": "cingalesa",
        "pt": "Sri Lanka",
        "code": "LK"
    },
    {
        "gentilico": "suazi",
        "pt": "Suazilândia",
        "code": "SZ"
    },
    {
        "gentilico": "sudanesa",
        "pt": "Sudão",
        "code": "SD"
    },
    {
        "gentilico": "sul-sudanês",
        "pt": "Sudão do Sul",
        "code": "SS"
    },
    {
        "gentilico": "sueca",
        "pt": "Suécia",
        "code": "SE"
    },
    {
        "gentilico": "suíça",
        "pt": "Suíça",
        "code": "CH"
    },
    {
        "gentilico": "surinamesa",
        "pt": "Suriname",
        "code": "SR"
    },
    {
        "gentilico": "svalbardense",
        "pt": "Svalbard",
        "code": "SJ"
    },
    {
        "gentilico": "tadjique",
        "pt": "Tadjiquistão",
        "code": "TJ"
    },
    {
        "gentilico": "tailandesa",
        "pt": "Tailândia",
        "code": "TH"
    },
    {
        "gentilico": "taiwanês",
        "pt": "Taiwan",
        "code": "TW"
    },
    {
        "gentilico": "tanzaniana",
        "pt": "Tanzânia",
        "code": "TZ"
    },
    {
        "gentilico": "do território britânico do oceano índico",
        "pt": "Território Britânico do Oceano índico",
        "code": "IO"
    },
    {
        "gentilico": "do territórios do sul da frança",
        "pt": "Territórios do Sul da França",
        "code": "TF"
    },
    {
        "gentilico": "timorense",
        "pt": "Timor-Leste",
        "code": "TL"
    },
    {
        "gentilico": "togolesa",
        "pt": "Togo",
        "code": "TG"
    },
    {
        "gentilico": "tonganesa",
        "pt": "Tonga",
        "code": "TO"
    },
    {
        "gentilico": "trinitário-tobagense",
        "pt": "Trinidad e Tobago",
        "code": "TT"
    },
    {
        "gentilico": "tunisiana",
        "pt": "Tunísia",
        "code": "TN"
    },
    {
        "gentilico": "turcomana",
        "pt": "Turcomenistão",
        "code": "TM"
    },
    {
        "gentilico": "turca",
        "pt": "Turquia",
        "code": "TR"
    },
    {
        "gentilico": "tuvaluana",
        "pt": "Tuvalu",
        "code": "TV"
    },
    {
        "gentilico": "ucraniana",
        "pt": "Ucrânia",
        "code": "UA"
    },
    {
        "gentilico": "ugandense",
        "pt": "Uganda",
        "code": "UG"
    },
    {
        "gentilico": "uruguaia",
        "pt": "Uruguai",
        "code": "UY"
    },
    {
        "gentilico": "uzbeque",
        "pt": "Uzbequistão",
        "code": "UZ"
    },
    {
        "gentilico": "vanuatuense",
        "pt": "Vanuatu",
        "code": "VU"
    },
    {
        "gentilico": "vaticano",
        "pt": "Vaticano",
        "code": "VA"
    },
    {
        "gentilico": "venezuelana",
        "pt": "Venezuela",
        "code": "VE"
    },
    {
        "gentilico": "vietnamita",
        "pt": "Vietnã",
        "code": "VN"
    },
    {
        "gentilico": "wallis-futunense",
        "pt": "Wallis e Futuna",
        "code": "WF"
    },
    {
        "gentilico": "zambiana",
        "pt": "Zâmbia",
        "code": "ZM"
    },
    {
        "gentilico": "zimbabuana",
        "pt": "Zimbábue",
        "code": "ZW"
    }
];

export default countriesPt;